import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../app/store';
import fetchAPI from '../../common/fetchAPI'
import { TaskStateClass } from './interfaces/TaskStateClass';
import moment from 'moment';
import {
    CREATE_EVENT_CALENDAR,
    DELETE_EVENT_CALENDAR,
    GET_ALL_EVENTS_CALENDAR,
    UPDATE_EVENT_CALENDAR,
  } from './task/eventCalendarRoutes';

const initialState: TaskStateClass = {
    isReloadTaskAllocationHours: false,
    isLoading: true,
    isCanvasLoading: false,
    isCanvasOpen: false,
    status: 'idle',
    accessToken: '',
    accountProjectId: 79464,
    accountProjectTaskId: 0,
    defaultCurrencyId: 16366,
    ////////
    taskTeamList: [],
    addTaskTeamList: [],
    selectedTaskTeamList: [],
    deletedTaskTeamList: [],
    ////////
    remainderTeamList: [],
    addRemainderTaskTeamList: [],
    selectRemainderTaskTeamList: [],
    deletedRemainderTaskTeamList: [],
    projectTaskTeamAllocationHoursList: [],
    ////
    //dependenciesList: [{ "AccountProjectTaskId": 0, "name": "Dummy Task", "dependencyType": "Start-Finish", "SystemTaskDependencyTypeId": 1, "SystemTaskPredecessorLagUnitType":"Days", "SystemTaskPredecessorLagUnitTypeId": 1, "TaskPredecessorLagUnit": "0", "isSelected": true }],
    dependenciesList: [],
    accountProjectTaskList: [],
    //pagination
    startRec: 0,
    search: '',
    pageNo: 1,
    pageSize: 10,
    totalItems: 0,
    recordsFiltered: 0,
    isSearch: false,
    isShowGrid: false,
    assignProjectTaskList: [],    
    startDate: new Date().toISOString(),
    endDate: new Date().toISOString(),
    FilterValues: {
        AccountProjectId: 0,
        AccountTaskTypeId: 0,
        AccountMilestoneId: 0,
        AccountCompleteStatusId: -1,
        AccountStatusId: 0,
        StartDate: new Date().toISOString(),
        EndDate: new Date().toISOString(),
        IncludeDateRange: false,
        Description : '',
        IsDisabled : 0
    }
}


interface ICreateEventCalendar {
    eventCalendar: {
      title: string;
      EndDate: Date;
      StartDate: Date;
      backgroundColor: string;
      textColor: string;
    };
  }


interface IThunkApi {
    state: {
        task: TaskStateClass;
    },
}

export const getProjectTaskTeam = createAsyncThunk
    <any, void, IThunkApi>
    (
        'task/getProjectTaskTeam',
        async (arg, thunkApi) => {
            const { accountProjectId, accountProjectTaskId, accessToken } = thunkApi.getState().task;
            const response = await fetchAPI(`api/Tasks/GetTaskTeamMembers/${accountProjectId}/${accountProjectTaskId}`, `Get`, '', true, accessToken);
            const json = await response.json();
            return json;
        }
    )

    export const getAssignedProjectTaskList = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Projects/getAssignedProjecTasktList',
        async (arg, thunkApi) => {
            const { startRec, search, pageNo, pageSize, accessToken } = thunkApi.getState().task;
            const response = await fetchAPI(`api/V2/Tasks/GetAssignedProjectTasksDatatable/${Number(arg)}/${startRec}/${pageSize}/${pageNo}/${search}`, `Get`, '', true, accessToken);
            const json = await response.json();
            return json;
        }
    )

export const getTaskTeamReminder = createAsyncThunk
    <any, void, IThunkApi>
    (
        'task/getTaskTeamReminder',
        async (arg, thunkApi) => {
            const { accountProjectId, accountProjectTaskId, accessToken } = thunkApi.getState().task;
            const response = await fetchAPI(`api/Tasks/GetTaskTeamReminder/${accountProjectId}/${accountProjectTaskId}`, `Get`, '', true, accessToken);
            const json = await response.json();
            return json;
        }
    )

export const getProjectTaskList = createAsyncThunk
    <any, any, IThunkApi>
    (
        'task/getProjectTaskList',
        async (arg, thunkApi) => {
            const { accountProjectId, startRec, search, pageNo, pageSize, accessToken } = thunkApi.getState().task;
            const response = await fetchAPI(`api/Tasks/GetAccountProjectTaskForReactTable/${Number(arg)}/${startRec}/${pageSize}/${pageNo}/${search}`, `Get`, '', true, accessToken);
            const json = await response.json();
            return json;
        }
    )

    export const getProjectTaskListForCalendarView = createAsyncThunk
    <any, any, IThunkApi>
    (
        'task/GetTaskDataForCalendarView',
        async (arg, thunkApi) => {
            const { accountProjectId, accessToken } = thunkApi.getState().task;
            const response = await fetchAPI(`api/V2/Tasks/TaskDataForCalendarView/${Number(arg)}`, `Get`, '', true, accessToken);
            const json = await response.json();
            return json;
        }
    )

export const getProjectTaskPredecessorList = createAsyncThunk
    <any, void, IThunkApi>
    (
        'task/getProjectTaskPredecessorList',
        async (arg, thunkApi) => {
            const { accountProjectTaskId, accessToken } = thunkApi.getState().task;
            const response = await fetchAPI(`api/TaskPredecessor/GetAccountProjectTaskPredecessor/${accountProjectTaskId}`, `Get`, '', true, accessToken);
            const json = await response.json();
            return json;
        }
    )

        export const getDataByAllocationHours = createAsyncThunk<
        any, { accountProjectId: number, accountProjectTaskId: number, accountEmployeeId: number, accountProjectTaskEmployeeId: number }, IThunkApi
    >(
        'project/getProjectTeam',
        async ({ accountProjectId, accountProjectTaskId, accountEmployeeId, accountProjectTaskEmployeeId }, thunkApi) => {
            const response = await fetchAPI(
                `api/V2/Tasks/GetDataByAllocationHours/${accountProjectTaskId}/${accountEmployeeId}`, 
                `Get`, '', true
            );
            const json = await response.json();
            return json;
        }
    );

    export const getMyTasksDatatable = createAsyncThunk
    <any, any, IThunkApi>
    (
       'task/getMyTasksDatatable',
        async (arg, thunkApi) => {
            const { AccountEmployeeId } = arg;
            const { ExpenseSheetStatusId } = arg;
            const { IncludeDateRange } = arg;
            const { StartDate } = arg;
            const { EndDate } = arg;
            const { accessToken } = thunkApi.getState().task;
            const response = await fetchAPI('api/V2/Tasks/GetMyTasksDatatable/${startRec}/${pageSize}/${pageNo}/${search}', 'Get', '', true , accessToken);
            const json = await response.json();
            return json;
        }
    )
export const deleteAccountProjectTaskPredecessor = createAsyncThunk
    <any, any, IThunkApi>
    (
        'task/deleteAccountProjectTaskPredecessor',
        async (arg, thunkApi) => {
            const { accessToken } = thunkApi.getState().task;
            const response = await fetchAPI(`api/TaskPredecessor/${Number(arg)}`, `Delete`, '', true, accessToken);
            const json = await response.json();
            return json;
        }
    )

    export const deleteAllocationHours = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Projects/deleteAllocationHours",
        async (arg, thunkApi) => {
            const response = await fetchAPI(`api/v2/Tasks/DeleteAllocationHours/${arg}`, 'Delete', arg, true);
            const json = await response.json();
            return json;

        }
    )

export const addAccountProjectTask = createAsyncThunk
    <any, any, IThunkApi>
    (
        'task/addAccountProjectTask',
        async (arg, thunkApi) => {
            try {
                const { accessToken } = thunkApi.getState().task;
                const response = await fetchAPI('api/Tasks/AddTaskRecord', 'POST', arg, true, accessToken);
                const json = await response.json();
                let reduxObject = {
                    "AccountProjectId": arg.AccountProjectId,
                    "AccountProjectTaskId": 0,
                    "DeadlineDate": moment(arg.DeadlineDate).format('DD MMM yy'),
                    "IsDisabled": arg.IsDisabled,
                    "Orig_CompletedPercent": arg.CompletedPercent,
                    "Orig_TaskName": arg.TaskName,
                    "Priority": arg.Priority,
                    "Status": arg.Status,
                    "TotalHours": arg.duration
                }
                return { json, reduxObject };
                /* if (response.status == 403) {
                    const json = await response.json();
                    return thunkApi.rejectWithValue(({ ...json[0], oldAccountEmployeeTimeEntryId: arg.AccountEmployeeTimeEntryId, RowId: arg.RowId, DetailRowId: arg.DetailRowId }))
                }
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                return { ...json, oldAccountEmployeeTimeEntryId: arg.AccountEmployeeTimeEntryId, RowId: arg.RowId, DetailRowId: arg.DetailRowId, decimalFormat }; */
            }
            catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

    export const addAccountProjectTaskEmployeeAllocationHoursAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Projects/addAccountProjectTaskEmployeeAllocationHours",
        async (arg, thunkApi) => {
            const { AccountProjectTaskEmployeeAllocationHoursId, ...argWithoutId } = arg;
            const response = await fetchAPI("api/v2/Tasks/AddAllocationHours/", "POST", arg, true);
            const json = response.json();
            return json;
        }
    )

    export const updateAccountProjectTaskEmployeeAllocationHoursAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Projects/updateAccountProjectTaskEmployeeAllocationHours",
        async (arg, thunkApi) => {
            const { AccountProjectTaskEmployeeAllocationHoursId, ...argWithoutId } = arg;
            const response = await fetchAPI("api/v2/Tasks/UpdateAccountProjectTaskEmployeeAllocationHours/" + AccountProjectTaskEmployeeAllocationHoursId, "POST", arg, true);
            const json = response.json();
            return json;
        }
    )

export const updateAccountProjectTask = createAsyncThunk
    <any, any, IThunkApi>
    (
        'task/updateAccountProjectTask',
        async (arg, thunkApi) => {
            try {
                const { accountProjectTaskId, accessToken } = thunkApi.getState().task;
                const response = await fetchAPI(`api/Tasks/UpdateTaskRecord/${accountProjectTaskId}`, 'POST', arg, true, accessToken);
                const json = await response.json();
                let reduxObject = {
                    "AccountProjectId": arg.Task.AccountProjectId,
                    "AccountProjectTaskId": accountProjectTaskId,
                    "DeadlineDate": moment(arg.Task.DeadlineDate).format('DD MMM yy'),
                    "IsDisabled": arg.Task.IsDisabled,
                    "Orig_CompletedPercent": arg.Task.CompletedPercent,
                    "Orig_TaskName": arg.Task.TaskName,
                    "Priority": arg.Priority,
                    "Status": arg.Status,
                    "TotalHours": arg.Task.duration
                }
                return { json, reduxObject };
            }
            catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const deleteAccountProjectTask = createAsyncThunk
    <any, any, IThunkApi>
    (
        'task/deleteAccountProjectTask',
        async (arg, thunkApi) => {
            const { accessToken } = thunkApi.getState().task;
            const response = await fetchAPI(`api/Tasks/${Number(arg)}`, `Delete`, '', true, accessToken);
            const json = await response.json();
            return json;
        }
    )

    export const addKanbanTask = createAsyncThunk
    <any, any, IThunkApi>(
        'Tasks/AddCalendarTask',
        async (args, ThunkApi) => {
            const { AccountProjectId, AccountProjectTaskId, title, StartDate, EndDate } = args
            console.log(AccountProjectId, AccountProjectTaskId, title, StartDate, EndDate);
            const response = await fetchAPI(`api/V2/Tasks/AddCalendarTask/${AccountProjectId}/${title}/${StartDate}/${EndDate}`, 'POST', '', true)
            const json = await response.json();
            let reduxObject = {
                "AccountProjectId": args.AccountProjectId,
                "AccountProjectTaskId": 0,
                "StartDate": moment(args.StartDate).format('DD MMM yy'),
                "DeadlineDate": moment(args.EndDate).format('DD MMM yy'),                
                "Orig_TaskName": args.TaskName,
                "TotalHours": args.duration,
                "IsDisabled": args.IsDisabled,
            }
            return { json, reduxObject };
        }
    )

    export const updateKanbanTask = createAsyncThunk
    <any, any, IThunkApi>(
        'Tasks/UpdateCalendarTask',
        async (args, ThunkApi) => {
            const { AccountProjectId, AccountProjectTaskId, title, StartDate, EndDate } = args
            console.log(AccountProjectId, AccountProjectTaskId, title, StartDate, EndDate);
            const response = await fetchAPI(`api/V2/Tasks/UpdateCalendarTask/${AccountProjectId}/${AccountProjectTaskId}/${title}/${StartDate}/${EndDate}`, 'POST', '', true)
            const json = await response.json();
            let reduxObject = {
                "AccountProjectId": args.AccountProjectId,
                "AccountProjectTaskId": args.AccountProjectTaskId,
                "StartDate": moment(args.StartDate).format('DD MMM yy'),
                "DeadlineDate": moment(args.EndDate).format('DD MMM yy'),                
                "Orig_TaskName": args.TaskName,
                "TotalHours": args.duration,
                "IsDisabled": args.IsDisabled,
            }
            return { json, reduxObject };
        }
    )

export const taskSlice = createSlice({
    name: 'task',
    initialState,
    reducers: {
        updateSelectedResource: (state, action: PayloadAction<any>) => {
            const index = state.taskTeamList.findIndex((item) => item.Id === action.payload);
            if (state.accountProjectTaskId != 0) {
                let selectedTaskTeamListIndexs = state.selectedTaskTeamList.findIndex((item) => item.Id === action.payload);
                let addTeamlistIndexs = state.addTaskTeamList.findIndex((item) => item.Id === action.payload);
                let deletedTaskTeamListIndex = state.deletedTaskTeamList.findIndex((item) => item.Id === action.payload);
                var obj = state.taskTeamList[index];
                if (selectedTaskTeamListIndexs == -1 && addTeamlistIndexs == -1 && deletedTaskTeamListIndex == -1) {
                    obj.IncludeTeam = 1;
                    state.addTaskTeamList.push(state.taskTeamList[index]);
                }
                if (selectedTaskTeamListIndexs == -1 && deletedTaskTeamListIndex != -1) {
                    obj.IncludeTeam = 1;
                    state.selectedTaskTeamList.push(state.deletedTaskTeamList[deletedTaskTeamListIndex]);
                    state.deletedTaskTeamList.splice(state.deletedTaskTeamList.findIndex((item) => item.Id === action.payload), 1);
                }
            } else {
                const newArray = [...state.taskTeamList];
                newArray[index] = { ...newArray[index], IncludeTeam: 1 };
                state.taskTeamList = newArray;
            }
        },
        updateUnSelectedResource: (state, action: PayloadAction<any>) => {
            const index = state.taskTeamList.findIndex((item) => item.Id === action.payload);
            if (state.accountProjectTaskId != 0) {
                let selectedTaskTeamListIndexs = state.selectedTaskTeamList.findIndex((item) => item.Id === action.payload);
                let addTeamlistIndexs = state.addTaskTeamList.findIndex((item) => item.Id === action.payload);
                var obj = state.taskTeamList[index];
                if (addTeamlistIndexs != -1) {
                    obj.IncludeTeam = 0;
                    state.addTaskTeamList.splice(state.addTaskTeamList.findIndex((item) => item.Id === action.payload), 1);
                }
                if (selectedTaskTeamListIndexs != -1 && addTeamlistIndexs == -1) {
                    obj.IncludeTeam = 0;
                    state.deletedTaskTeamList.push(state.selectedTaskTeamList[selectedTaskTeamListIndexs]);
                    state.selectedTaskTeamList.splice(state.selectedTaskTeamList.findIndex((item) => item.Id === action.payload), 1);
                }
            } else {
                const newArray = [...state.taskTeamList];
                newArray[index] = { ...newArray[index], IncludeTeam: 0 };
                state.taskTeamList = newArray;
            }
        },
        updateAllSelectedAndUnSelected: (state, action: PayloadAction<any>) => {
            state.taskTeamList = action.payload;
        },
        selectedAndUnSelectedOnEditMode: (state, action: PayloadAction<any>) => {
            state.taskTeamList.map((item) => {
                if (action.payload) {
                    let employeeObject;
                    let deletedTaskTeamListIndex = state.deletedTaskTeamList.findIndex(x => x.Id == item.Id);
                    if (deletedTaskTeamListIndex != -1) {
                        item.IncludeTeam = 1;
                        state.selectedTaskTeamList.push(state.deletedTaskTeamList[deletedTaskTeamListIndex]);
                        state.deletedTaskTeamList.splice(state.deletedTaskTeamList.findIndex((deleteItem) => deleteItem.Id === item.Id), 1);
                    }
                    state.selectedTaskTeamList.filter(selectItem => selectItem.Id == item.Id).map((item, index) => {
                        employeeObject = item.Id
                    });
                    if (employeeObject != item.Id) {
                        item.IncludeTeam = 1;
                        if (state.addTaskTeamList.findIndex(x => x.Id == item.Id) == -1) {
                            state.addTaskTeamList.push(item);
                        }
                    }
                } else {
                    item.IncludeTeam = 0;
                    let selectedTaskTeamListIndex = state.selectedTaskTeamList.findIndex(x => x.Id == item.Id);
                    if (selectedTaskTeamListIndex != -1) {
                        state.deletedTaskTeamList.push(state.selectedTaskTeamList[selectedTaskTeamListIndex]);
                        state.selectedTaskTeamList.splice(state.selectedTaskTeamList.findIndex(x => x.Id == item.Id), 1);
                    }
                    state.addTaskTeamList.splice(state.addTaskTeamList.findIndex(x => x.Id == item.Id), 1);
                }
            });
        },
        updateEmployeeCost: (state, action: PayloadAction<any>) => {
            const { hours, employeeRate, accountEmployeeId } = action.payload;
            const index = state.taskTeamList.findIndex((item) => item.Id === accountEmployeeId);
            const newArray = [...state.taskTeamList];
            // newArray[index] = { ...newArray[index], cost: hours * employeeRate, employeeHours: hours };
            newArray[index] = { ...newArray[index], ResourceCost: hours * employeeRate, AllocationHours: hours };
            state.taskTeamList = newArray;
        },
        updateSelectedRemainderTeam: (state, action: PayloadAction<any>) => {
            const index = state.remainderTeamList.findIndex((item) => item.Id === action.payload);
            if (state.accountProjectTaskId != 0) {
                let selectedTaskTeamListIndexs = state.selectRemainderTaskTeamList.findIndex((item) => item.Id === action.payload);
                let addTeamlistIndexs = state.addRemainderTaskTeamList.findIndex((item) => item.Id === action.payload);
                let deletedTaskTeamListIndex = state.deletedRemainderTaskTeamList.findIndex((item) => item.Id === action.payload);
                var obj = state.remainderTeamList[index];
                if (selectedTaskTeamListIndexs == -1 && addTeamlistIndexs == -1 && deletedTaskTeamListIndex == -1) {
                    obj.IncludeTeam = 1;
                    state.addRemainderTaskTeamList.push(state.remainderTeamList[index]);
                }
                if (selectedTaskTeamListIndexs == -1 && deletedTaskTeamListIndex != -1) {
                    obj.IncludeTeam = 1;
                    state.selectRemainderTaskTeamList.push(state.deletedRemainderTaskTeamList[deletedTaskTeamListIndex]);
                    state.deletedRemainderTaskTeamList.splice(state.deletedRemainderTaskTeamList.findIndex((item) => item.Id === action.payload), 1);
                }
            } else {
                const newArray = [...state.remainderTeamList];
                newArray[index] = { ...newArray[index], IncludeTeam: 1 };
                state.remainderTeamList = newArray;
            }
        },
        updateUnSelectedRemainderTeam: (state, action: PayloadAction<any>) => {
            const index = state.remainderTeamList.findIndex((item) => item.Id === action.payload);
            if (state.accountProjectTaskId != 0) {
                let selectedTaskTeamListIndexs = state.selectRemainderTaskTeamList.findIndex((item) => item.Id === action.payload);
                let addTeamlistIndexs = state.addRemainderTaskTeamList.findIndex((item) => item.Id === action.payload);
                var obj = state.remainderTeamList[index];
                if (addTeamlistIndexs != -1) {
                    obj.IncludeTeam = 0;
                    state.addRemainderTaskTeamList.splice(state.addRemainderTaskTeamList.findIndex((item) => item.Id === action.payload), 1);
                }
                if (selectedTaskTeamListIndexs != -1 && addTeamlistIndexs == -1) {
                    obj.IncludeTeam = 0;
                    state.deletedRemainderTaskTeamList.push(state.selectRemainderTaskTeamList[selectedTaskTeamListIndexs]);
                    state.selectRemainderTaskTeamList.splice(state.selectRemainderTaskTeamList.findIndex((item) => item.Id === action.payload), 1);
                }
            } else {
                const newArray = [...state.remainderTeamList];
                newArray[index] = { ...newArray[index], IncludeTeam: 0 };
                state.remainderTeamList = newArray;
            }
        },
        updateSelectUnSelectRemainderTeam: (state, action: PayloadAction<any>) => {
            state.remainderTeamList = action.payload;
        },
        selectUnSelectRemainderTeamOnEditMode: (state, action: PayloadAction<any>) => {
            state.remainderTeamList.map((item) => {
                if (action.payload) {
                    let employeeObject;
                    let deletedTaskTeamListIndex = state.deletedRemainderTaskTeamList.findIndex(x => x.Id == item.Id);
                    if (deletedTaskTeamListIndex != -1) {
                        item.IncludeTeam = 1;
                        state.selectRemainderTaskTeamList.push(state.deletedRemainderTaskTeamList[deletedTaskTeamListIndex]);
                        state.deletedRemainderTaskTeamList.splice(state.deletedRemainderTaskTeamList.findIndex((deleteItem) => deleteItem.Id === item.Id), 1);
                    }
                    state.selectRemainderTaskTeamList.filter(selectItem => selectItem.Id == item.Id).map((item, index) => {
                        employeeObject = item.Id
                    });
                    if (employeeObject != item.Id) {
                        item.IncludeTeam = 1;
                        if (state.addRemainderTaskTeamList.findIndex(x => x.Id == item.Id) == -1) {
                            state.addRemainderTaskTeamList.push(item);
                        }
                    }
                } else {
                    item.IncludeTeam = 0;
                    let selectedTaskTeamListIndex = state.selectRemainderTaskTeamList.findIndex(x => x.Id == item.Id);
                    if (selectedTaskTeamListIndex != -1) {
                        state.deletedRemainderTaskTeamList.push(state.selectRemainderTaskTeamList[selectedTaskTeamListIndex]);
                        state.selectRemainderTaskTeamList.splice(state.selectRemainderTaskTeamList.findIndex(x => x.Id == item.Id), 1);
                    }
                    state.addRemainderTaskTeamList.splice(state.addRemainderTaskTeamList.findIndex(x => x.Id == item.Id), 1);
                }
            });
        },
        addRowInDependencyList: (state, action: PayloadAction<any>) => {
            const newArray = [...state.dependenciesList, action.payload];
            state.dependenciesList = newArray;
        },
        updateDependencyList: (state, action: PayloadAction<any>) => {
            state.dependenciesList.map((item: any) => {
                item.isSelected = false;
            });
            const index = state.dependenciesList.findIndex((item) => item.AccountProjectTaskId === action.payload);
            const newArray = [...state.dependenciesList];
            // newArray[index] = { ...newArray[index], isSelected: (newArray[index].isSelected ? false : true) };
            newArray[index] = { ...newArray[index], isSelected: true };
            state.dependenciesList = newArray;
        },
        removeFromDependencyList: (state, action: PayloadAction<any>) => {
            state.dependenciesList = state.dependenciesList.filter(item => item.AccountProjectTaskId != action.payload);
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageNo = action.payload.pageNumber;
            state.startRec = action.payload.start;
            state.search = action.payload.search;
        },
        updateSearchPagination: (state, action: PayloadAction<any>) => {
            state.isSearch = state.isSearch ? false : true;
            state.search = action.payload;
        },
        addTaskInPredecessor: (state, action: PayloadAction<any>) => {
            // const index = state.dependenciesList.findIndex((item) => item.AccountProjectTaskId === 0);
            const index = state.dependenciesList.findIndex((item) => (action.payload.byTaskPredecessorId ? item.AccountProjectTaskPredecessorId : item.AccountProjectTaskId) === action.payload.Id);
            const newArray = [...state.dependenciesList];
            // newArray[index] = { ...newArray[index], AccountProjectTaskId: action.payload };
            newArray[index] = { ...newArray[index], AccountProjectTaskId: action.payload.value, TaskName: action.payload.LabelName };
            state.dependenciesList = newArray;
        },
        addDependencyType: (state, action: PayloadAction<any>) => {
            // const index = state.dependenciesList.findIndex((item) => item.AccountProjectTaskId === action.payload.Id);
            const index = state.dependenciesList.findIndex((item) => (action.payload.byTaskPredecessorId ? item.AccountProjectTaskPredecessorId : item.AccountProjectTaskId) === action.payload.Id);
            const newArray = [...state.dependenciesList];
            newArray[index] = { ...newArray[index], SystemTaskDependencyTypeId: action.payload.value, SystemTaskDependencyType: action.payload.LabelName };
            state.dependenciesList = newArray;
        },
        addDependencyLagUnitTypeId: (state, action: PayloadAction<any>) => {
            // const index = state.dependenciesList.findIndex((item) => item.AccountProjectTaskId === action.payload.Id);
            const index = state.dependenciesList.findIndex((item) => (action.payload.byTaskPredecessorId ? item.AccountProjectTaskPredecessorId : item.AccountProjectTaskId) === action.payload.Id);
            const newArray = [...state.dependenciesList];
            newArray[index] = { ...newArray[index], SystemTaskPredecessorLagUnitTypeId: action.payload.value, SystemTaskPredecessorLagUnitType: action.payload.LabelName };
            state.dependenciesList = newArray;
        },
        addDependencyLagUnit: (state, action: PayloadAction<any>) => {
            const index = state.dependenciesList.findIndex((item) => (action.payload.byTaskPredecessorId ? item.AccountProjectTaskPredecessorId : item.AccountProjectTaskId) === action.payload.Id);
            const newArray = [...state.dependenciesList];
            newArray[index] = { ...newArray[index], TaskPredecessorLagUnit: Number(action.payload.value) };
            state.dependenciesList = newArray;
        },
        updateAccountProjectTaskId: (state, action: PayloadAction<any>) => {
            state.accountProjectTaskId = action.payload;
            //state.isCanvasLoading = true;
        },
        updateIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        updateIsCanvasLoading: (state, action: PayloadAction<boolean>) => {
            state.isCanvasLoading = action.payload;
        },
        emptyDependencyList:(state)=>{
            state.dependenciesList = []
        },
        updateMyTaskFilters: (state, action: PayloadAction<any>) => {
            state.FilterValues = { ...state.FilterValues, ...action.payload };
        },
        isEditableAllocationHoursList: (state, action) => {      
            const currentindex = state.projectTaskTeamAllocationHoursList.findIndex((item) => item.AccountProjectTaskEmployeeAllocationHoursId == action.payload);
            const newArray = [...state.projectTaskTeamAllocationHoursList];
            newArray[currentindex] = { ...newArray[currentindex], IsEditable: true };
            state.projectTaskTeamAllocationHoursList = newArray;
        },
        setDatesAllocationHours: (state, action) => {            
            
            const index = state.projectTaskTeamAllocationHoursList.findIndex((item) => item.AccountProjectTaskEmployeeAllocationHoursId === action.payload.Id);
            const newArray = [...state.projectTaskTeamAllocationHoursList];          
            if(action.payload.StartDate || action.payload.StartDate === null){
                newArray[index] = { ...newArray[index], StartDate: action.payload.StartDate !== null && action.payload.StartDate != '' ? action.payload.StartDate : ''};               
            }else{
                newArray[index] = { ...newArray[index], EndDate: action.payload.EndDate !== null && action.payload.EndDate != '' ? action.payload.EndDate : ''};               
            }
            
             state.projectTaskTeamAllocationHoursList = newArray;
        },
        setValuesAllocationHours: (state, action) => {            
            const index = state.projectTaskTeamAllocationHoursList.findIndex((item) => item.AccountProjectTaskEmployeeAllocationHoursId === action.payload.Id);
            const newArray = [...state.projectTaskTeamAllocationHoursList];          
            newArray[index] = { ...newArray[index], AllocationHours: action.payload.AllocationHours != '' ? action.payload.AllocationHours : 0};               
             state.projectTaskTeamAllocationHoursList = newArray;
        },

    },
    extraReducers: (builder) => {
        builder
            .addCase(getProjectTaskTeam.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getProjectTaskTeam.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.taskTeamList = payload;
                state.remainderTeamList = payload;
                payload.map((item: any) => {
                    if (item.IncludeTeam == 1) {
                        state.selectedTaskTeamList.push(item);
                    }
                });
            })
            .addCase(getProjectTaskTeam.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(getDataByAllocationHours.pending, (state) => {
                state.status = 'loading';
            })
                .addCase(getDataByAllocationHours.fulfilled, (state, { payload, meta }) => {
                    state.status = 'idle';
                        // Blank row ko pehle add karein
    const blankRow = {
        AccountProjectTaskEmployeeAllocationHoursId: 0,
        StartDate: '',
        EndDate: '',
        AllocationHours: 0,
        AccountProjectId: meta.arg.accountProjectId,
        AccountProjectTaskId: meta.arg.accountProjectTaskId,
        AccountEmployeeId: meta.arg.accountEmployeeId,
        AccountProjectTaskEmployeeId: meta.arg.accountProjectTaskEmployeeId
    };
                    //state.projectTeamAllocationHoursList = payload;
                    state.projectTaskTeamAllocationHoursList = [blankRow, ...payload];
                    state.isReloadTaskAllocationHours = false

                    
                })
                .addCase(getDataByAllocationHours.rejected, (state) => {
                    state.status = 'failed';
                })
            .addCase(getTaskTeamReminder.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getTaskTeamReminder.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.remainderTeamList.map((item: any) => {
                    if (payload.filter((x: any) => x.AccountEmployeeId == item.Id).length > 0) {
                        item.IncludeTeam = 1;
                        state.selectRemainderTaskTeamList.push(item);
                    } else {
                        item.IncludeTeam = 0;
                    }
                });
            })
            .addCase(getTaskTeamReminder.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(getProjectTaskList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getProjectTaskList.fulfilled, (state, action) => {
                JSON.parse(action.payload.data).map((item: any) => {
                    delete item.Completed;
                    delete item.CompletedPercent;
                    delete item.Level;
                    delete item.StartDate;
                    delete item.TaskName;
                    delete item.TaskStatusId;
                })
                state.accountProjectTaskList = JSON.parse(action.payload.data);
                state.isShowGrid = JSON.parse(action.payload.data).length > 0 ? true : false;
                state.pageNo = action.payload.currentPage;
                state.startRec = action.payload.start;
                state.totalItems = action.payload.recordsTotal;
                state.search = action.payload.searchText;
                state.recordsFiltered = action.payload.recordsFiltered;
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(getProjectTaskList.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(getMyTasksDatatable.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getMyTasksDatatable.fulfilled, (state, { payload }) => {           
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(getMyTasksDatatable.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })



            .addCase(addAccountProjectTask.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(addAccountProjectTask.fulfilled, (state, action) => {
                action.payload.reduxObject.AccountProjectTaskId = action.payload.json[0].id;
                state.accountProjectTaskList.unshift(action.payload.reduxObject);
                state.isLoading = false;
                state.isCanvasLoading = false;
            })
            .addCase(addAccountProjectTask.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
                state.isCanvasLoading = false;
            })
            .addCase(addAccountProjectTaskEmployeeAllocationHoursAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(addAccountProjectTaskEmployeeAllocationHoursAsync.fulfilled, (state, action) => {
                state.projectTaskTeamAllocationHoursList = state.projectTaskTeamAllocationHoursList.filter(x => x.AccountProjectTaskEmployeeAllocationHoursId != Number(action.payload.id));
                
                state.status = 'idle';
                state.isLoading = false;
                console.log("Previous isReloadTaskAllocationHours:", action);
                if(action.payload.message !== "Error: Exceeds allowed task hours" && action.payload.Result !== "failed" && action.payload.message !== "Date range conflict detected for this employee."){
                    state.isReloadTaskAllocationHours = !state.isReloadTaskAllocationHours;
                } 

                console.log("Updated isReloadTaskAllocationHours:", state.isReloadTaskAllocationHours);
            })
            .addCase(addAccountProjectTaskEmployeeAllocationHoursAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
                state.isCanvasLoading = false;
            })
            .addCase(updateAccountProjectTaskEmployeeAllocationHoursAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateAccountProjectTaskEmployeeAllocationHoursAsync.fulfilled, (state, action) => {
                state.projectTaskTeamAllocationHoursList = state.projectTaskTeamAllocationHoursList.filter(x => x.AccountProjectTaskEmployeeAllocationHoursId != Number(action.payload.id));
                
                state.status = 'idle';
                state.isLoading = false;
                state.isReloadTaskAllocationHours = !state.isReloadTaskAllocationHours;
            })
            .addCase(updateAccountProjectTaskEmployeeAllocationHoursAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(updateAccountProjectTask.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateAccountProjectTask.fulfilled, (state, action) => {
                let obj = action.payload.reduxObject;
                state.accountProjectTaskList.map((item: any) => {
                    if (item.AccountProjectTaskId == action.payload.json[0].id) {
                        item.DeadlineDate = obj.DeadlineDate;
                        item.IsDisabled = obj.IsDisabled;
                        item.Orig_CompletedPercent = obj.Orig_CompletedPercent;
                        item.Orig_TaskName = obj.Orig_TaskName;
                        item.Priority = obj.Priority;
                        item.Status = obj.Status;
                        item.TotalHours = obj.TotalHours;
                    }
                });
                state.status = 'idle';
                state.isLoading = false;
                state.isCanvasLoading = false;
            })
            .addCase(updateAccountProjectTask.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
                state.isCanvasLoading = false;
            })
            .addCase(getProjectTaskPredecessorList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getProjectTaskPredecessorList.fulfilled, (state, action) => {
                action.payload.map((item: any) => {
                    item.isSelected = false
                });
                state.dependenciesList = action.payload;
            })
            .addCase(getProjectTaskPredecessorList.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(deleteAccountProjectTaskPredecessor.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteAccountProjectTaskPredecessor.fulfilled, (state, action) => {
                state.dependenciesList = state.dependenciesList.filter(item => item.AccountProjectTaskPredecessorId != Number(action.payload.id));

            })
            .addCase(deleteAccountProjectTaskPredecessor.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(deleteAccountProjectTask.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteAccountProjectTask.fulfilled, (state, action) => {
                state.accountProjectTaskList = state.accountProjectTaskList.filter(x => x.AccountProjectTaskId != action.payload.id);
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(deleteAccountProjectTask.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(deleteAllocationHours.pending, (state) => {
                state.status = 'loading';
            })
        .addCase(deleteAllocationHours.fulfilled, (state, action) => {
            state.projectTaskTeamAllocationHoursList = state.projectTaskTeamAllocationHoursList.filter(x => x.AccountProjectTaskEmployeeAllocationHoursId != Number(action.payload.id));
            
            state.status = 'idle';
            state.isLoading = false;
        })
        .addCase(deleteAllocationHours.rejected, (state) => {
            state.status = 'failed';
            state.isLoading = false;
        })
            .addCase(getProjectTaskListForCalendarView.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getProjectTaskListForCalendarView.fulfilled, (state, action) => {

                //state.accountProjectTaskList = JSON.parse(action.payload.Data.data);
                state.accountProjectTaskList = action.payload.Data.data;
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(getProjectTaskListForCalendarView.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(addKanbanTask.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(addKanbanTask.fulfilled, (state, action) => {
                action.payload.reduxObject.AccountProjectTaskId = action.payload.json.id;
                state.accountProjectTaskList.unshift(action.payload.reduxObject);
                state.isLoading = false;
                state.isCanvasLoading = false;
            })
            .addCase(addKanbanTask.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
                state.isCanvasLoading = false;
            })
            .addCase(updateKanbanTask.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateKanbanTask.fulfilled, (state, action) => {
                action.payload.reduxObject.AccountProjectTaskId = action.payload.json.id;
                state.accountProjectTaskList.unshift(action.payload.reduxObject);
                state.isLoading = false;
                state.isCanvasLoading = false;
            })
            .addCase(updateKanbanTask.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
                state.isCanvasLoading = false;
            })
            .addCase(getAssignedProjectTaskList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getAssignedProjectTaskList.fulfilled, (state, action) => {
                JSON.parse(action.payload.data).map((item: any) => {
                    delete item.Completed;
                    delete item.CompletedPercent;
                    delete item.Level;
                    delete item.StartDate;
                    delete item.TaskName;
                    delete item.TaskStatusId;
                })
                state.assignProjectTaskList = JSON.parse(action.payload.data);
                state.isShowGrid = JSON.parse(action.payload.data).length > 0 ? true : false;
                state.pageNo = action.payload.currentPage;
                state.startRec = action.payload.start;
                state.totalItems = action.payload.recordsTotal;
                state.search = action.payload.searchText;
                state.recordsFiltered = action.payload.recordsFiltered;
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(getAssignedProjectTaskList.rejected, (state) => {
                state.status = 'failed';
            })
    }
})

export const {
    updateSelectedResource,
    updateUnSelectedResource,
    updateAllSelectedAndUnSelected,
    selectedAndUnSelectedOnEditMode,
    updateEmployeeCost,
    updateSelectedRemainderTeam,
    updateUnSelectedRemainderTeam,
    updateSelectUnSelectRemainderTeam,
    selectUnSelectRemainderTeamOnEditMode,
    addRowInDependencyList,
    updateDependencyList,
    removeFromDependencyList,
    updatePagination,
    updateSearchPagination,
    addTaskInPredecessor,
    addDependencyType,
    addDependencyLagUnitTypeId,
    addDependencyLagUnit,
    updateAccountProjectTaskId,
    updateIsLoading,
    updateIsCanvasLoading,
    emptyDependencyList,
    updateMyTaskFilters,
    isEditableAllocationHoursList,
    setDatesAllocationHours,
    setValuesAllocationHours
} = taskSlice.actions

export const TaskState = (state: RootState) => state.task
export default taskSlice.reducer